import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#FFF",
		strokeLinecap: "round",
		strokeWidth: 3,
		transform: "translate(2 2)",
		children: [/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y2: 16
		}), /* @__PURE__ */ _jsx("line", {
			x2: 16,
			y2: 16
		})]
	})
});
export default SvgClose;
